import { toast } from 'react-toastify';
import { usersApi } from 'entities/users';
import { AddMechanicDataReqType } from 'features/addMechanic/types';

const addMechanicApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    addMechanic: builder.mutation<any, AddMechanicDataReqType>({
      query: ({ id, body }) => ({
        url: `/promo-b2b/admin/promo-b2b/admin/activities/${id}/add_objective/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно добавили новую механику', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
  }),
});

export const { useAddMechanicMutation } = addMechanicApi;
